module.exports = __webpack_public_path__ + "media/emergencia.564dd019.mp3";